"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./InteractionTagPrimary"), exports);
_export_star._(require("./InteractionTagPrimary.types"), exports);
_export_star._(require("./renderInteractionTagPrimary"), exports);
_export_star._(require("./useInteractionTagPrimary"), exports);
_export_star._(require("./useInteractionTagPrimaryStyles.styles"), exports);
